import React from "react"
import bmeLogo from "../../images/bme-logo.svg"

import SbEditable from "storyblok-react"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"

const MembershipBannerBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="w-full bg-primary-600">
        <div className="text-center py-block block-w-container">
          <div className="w-20 h-20 mx-auto bg-white border-4 border-white rounded-full">
            <Image
              className="object-contain object-center w-full h-full"
              image={bmeLogo}
            />
          </div>
          <span className="block mt-8 text-2xl font-semibold text-white">
            {block.text}
          </span>
          <Link
            className="mt-8 bg-white text-primary btn hover:text-primary-hover"
            link={block.link}
          >
            {block.link_text}
          </Link>
        </div>
      </section>
    </SbEditable>
  )
}

export default MembershipBannerBlock
